/*
 * @Author: Michael 
 * @Date: 2018-09-17 10:15:03 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-10-28 17:12:12
 */

import Vue from 'vue';
import Loading from '@/plugins/loading';
import Toast from '@/plugins/toast';
import Confirm from '@/plugins/confirm';
import Modal from '@/plugins/modal';

const components = [
  Loading,
  Toast,
];

const install = function (Vue: any) {
  components.map(item => {
    Vue.use(item);
  });
  Vue.$confirm = Vue.prototype.$confirm = Confirm;
  Vue.$modal = Vue.prototype.$modal = Modal;
};


if (typeof window != 'undefined' && window.Vue) {
  install(window.Vue);
}
export {
  install,
  Loading,
  Toast,
  Confirm,
  Modal,
}